module.exports = __webpack_public_path__ + "assets/img/heroBusiness.5292a8ee.jpg";